import { useState } from 'react';

// This hook was lifted from: https://github.com/juliencrn/usehooks-ts/blob/master/src/useCopyToClipboard/useCopyToClipboard.ts
// The package does not transpile optional chaining which causes tests in Cypress to fail.
const useCopyToClipboard = ()=>{
    const [copiedText, setCopiedText] = useState(null);
    const copy = async (text)=>{
        var _navigator;
        if (!((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.clipboard)) {
            // eslint-disable-next-line no-console
            console.warn("Clipboard not supported");
            return false;
        }
        // Try to save to clipboard then save it in the state if worked
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    };
    return [
        copiedText,
        copy
    ];
};

export { useCopyToClipboard };
